import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import TechImagePanel from '@/components/feature/TechImagePanel';
import Hero from './components/Hero';
import DataFlywheel from './components/DataFlywheel';
import TomaAI from './components/TomaAI';
import AIServiceProvider from './components/AIServiceProvider';

export default function DataAi() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="九畴云铺数据飞轮与AI | TOMA智能层与AI应用服务商"
        description="九畴云铺数据飞轮持续循环，TOMA AI作为商业网络智能层为消费者云社员云店长供应链平台提供智能决策，华辉数智作为AI应用服务商提供四大能力。"
        keywords="九畴云铺,数据飞轮,TOMA智能体,AI应用服务商,智能决策,数据闭环"
        path="/jiuchou/data-ai"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '九畴云铺数据飞轮与AI',
          description: 'TOMA智能层与AI应用服务商',
        }}
      />
      <main>
        <Hero />
        <DataFlywheel />
        <TechImagePanel
          eyebrow="数据与 AI"
          title="数据不是终点，而是下一次交易的起点"
          desc="数据飞轮持续循环，TOMA AI 作为商业网络的智能层，为每个角色提供智能决策。"
          chips={['数据飞轮', 'TOMA AI', '需求预测', '供应链优化']}
          stats={[
            { value: '6 类', label: '数据流' },
            { value: '5 角色', label: 'AI 服务' },
            { value: '4 能力', label: 'AI 应用服务商' },
          ]}
          imageUrl="https://readdy.ai/api/search-image?query=Abstract%20circular%20data%20flywheel%20with%20AI%20neural%20core%2C%20deep%20dark%20ink%20navy%20background%2C%20glowing%20emerald%20and%20gold%20orbiting%20data%20streams%20converging%20into%20a%20luminous%20intelligence%20node%2C%20digital%20commerce%20intelligence%2C%20minimal%20geometric%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1600&height=900&seq=jiuchou-panel-ai&orientation=landscape"
          imageAlt="九畴云铺 数据飞轮与 TOMA AI"
        />
        <TomaAI />
        <AIServiceProvider />
      </main>
      <Footer />
    </div>
  );
}